
import { ITeamWebsite, IWebsitePage } from "../../../services";
import { Utils } from "../../../utils";

export type TeamPage = keyof ITeamWebsite["website_pages"];

export const PAGE_ORDER: TeamPage[] = ["HOME", "MERCH", "SCHEDULE", "MEMBERS", "GALLERY", "ACTIVITIES", "ACHIEVEMENTS", "NEWS"];

export const DASHBOARD_URL = process.env.REACT_APP_OMNEHOST_DASHBOARD_URL ?? "http://127.0.0.1:3901";

export function pagePath(basePath: string, page: string) {
    return `/${basePath}${page === "HOME" ? "" : "/" + page.toLowerCase()}`;
}

export function visiblePages(website: ITeamWebsite): [string, IWebsitePage][] {
    return Utils.entriesInCustomOrder(website.website_pages as any, PAGE_ORDER).filter(([_, pageSettings]) => pageSettings.visible);
}

export function isPageVisible(website: ITeamWebsite, page: TeamPage) {
    return !!website.website_pages?.[page]?.visible;
}

export function teamLogo(website: ITeamWebsite): string | undefined {
    return website.team.logo_url ?? website.media?.LOGO?.[0];
}

export function teamBanner(website: ITeamWebsite): string | undefined {
    const banners = website.media?.BANNER;
    if (!banners?.length) return undefined;
    return banners[website.extra_data?.media?.BANNER?.active ?? 0] ?? banners[0];
}

export function teamInitials(name: string) {
    const parts = (name ?? "").trim().split(/\s+/);
    return parts.length > 1 ? parts.map((p) => p[0]).join("").toUpperCase() : (parts[0] ?? "").slice(0, 3).toUpperCase();
}

export function stripMarkdown(content: string, length = 140) {
    const text = (content ?? "").replace(/[#*_>`~[\]()!-]/g, "").replace(/\s+/g, " ").trim();
    return text.length > length ? text.substring(0, length).trim() + "…" : text;
}
